export declare namespace IncidentModalTokenSections {
	interface RadioLabel {
		color: string;
		fontSize: string;
		lineHeight: string;
	}

	interface RadioHint {
		color: string;
		fontSize: string;
		lineHeight: string;
	}
}

export type IncidentModalTokens = {
	radioLabel: IncidentModalTokenSections.RadioLabel;
	radioHint: IncidentModalTokenSections.RadioHint;
};

export const radioLabel: IncidentModalTokenSections.RadioLabel = {
	color: '{text.muted.color}',
	fontSize: '1rem',
	lineHeight: '1.625rem',
};

export const radioHint: IncidentModalTokenSections.RadioHint = {
	color: '{text.muted.color}',
	fontSize: '0.875rem',
	lineHeight: '1.25rem',
};

export default {
	radioLabel,
	radioHint,
} satisfies IncidentModalTokens;
